module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/ct-success.920d78a0.svg";